var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 5,
    viewBox: "0 0 209 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.667 2.38418C208.659 2.62882 205.736 2.82375 200.456 2.94248C195.176 3.06121 187.538 3.12597 178.098 3.1325C168.635 3.18279 157.468 2.88861 145.03 3.37703C138.812 3.57677 132.279 3.87763 125.44 4.01275C118.623 4.1486 111.569 4.05413 104.381 3.9776C90.0281 3.75852 76.3212 4.22821 63.8312 4.24744C51.3389 4.3334 40.0785 4.19202 30.6295 3.79751C21.182 3.35853 13.5825 2.9125 8.29667 2.519C3.03307 2.12622 0.126874 1.80964 0.134782 1.56501C0.14269 1.32037 3.06399 1.16992 8.34125 1.14015C13.6192 1.08813 21.2754 1.15753 30.6885 1.28372C40.1031 1.36543 51.3276 1.2385 63.7812 0.973187C76.2325 0.774598 89.9645 0.216674 104.407 0.416383C111.617 0.493638 118.627 0.586662 125.375 0.515382C132.147 0.378102 138.697 0.233633 144.913 0.100619C157.413 -0.22997 168.727 0.336121 178.135 0.617987C187.564 0.922812 195.19 1.25836 200.457 1.53995C205.723 1.84377 208.631 2.11587 208.623 2.3605L208.667 2.38418Z",
    fill: "#CCCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUnfilled);
export default __webpack_public_path__ + "static/media/LineUnfilled.0cbe6956a655ac3143ee2e54bbc55bbd.svg";
export { ForwardRef as ReactComponent };